export default "__VITE_ASSET__B1Ciol3Q__"